<template>
    <div :class="$style.root">
        <div class="w">

            <div v-if="liveVideoList.length>0">
                <div class="broadcast-box" @click="goVideoDetail(item.meeting_id,item.media_id,item.meeting_name)" v-for="(item, index) in liveVideoList" :key="index">
                    <div class="broadcast-img">
                        <img :src="baseUrl+'snaps/'+item.meeting_id+'.png'"  :onerror="defalutLogoUrl" />
                    </div>
                    <div class="broadcast-info">
                        <div class="meeting_name" style="color:#333">{{ item.meeting_name }}</div>
                        <div class="broadcast-info-line">
                            <div class="time">{{ item.teacher }}</div>
                        </div>
                        <div class="broadcast-info-line">
                            <div class="time">观看人数：{{ item.views>0?item.views:0}}</div>
                            <!-- {{ item.views>0?item.views:0}} -->
                        </div>
                        <div class="broadcast-info-line">
                            <div class="time">{{ item.createTime }}</div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div style="text-align:center; line-height:100px;" v-else>暂无内容</div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'CreateTerminologyDialog',
        filters: {
            newformatTime(data) {
                const hours = moment.duration(parseInt(data, 0)).hours();

                const seconds = moment.duration(parseInt(data, 0)).seconds();

                const minutes = moment.duration(parseInt(data, 0)).minutes();

                return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
            },
        },
        props: {
            liveVideoList: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                baseUrl: '',
                defalutLogoUrl: `this.src="${require('@/assets/live_defult.png')}"`,
            };
        },
        mounted() {
            const URL = `http://${document.domain}:8000/`;
            this.baseUrl = URL;
        },

        destroyed() {},

        methods: {
            ...mapActions('params', [
                'storageLiveParams',
            ]),
            // 跳转详情
            goVideoDetail(meetingId, mediaId, meetingName) {
                this.storageLiveParams({ meetingId, mediaId, meetingName });
                const data = {
                    meetingId, mediaId, meetingName,
                };
                const params = JSON.stringify(data);


                this.$router.push({ name: 'LiveDetailView', params: { params } });
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        max-width: 1200px;
        margin: 20px auto 0;
        height: auto;
        background: #f0f3f9;
        padding-top: 20px;
        :global {
            .w {
                max-width: 1180px;
                margin: 0 auto;

                .broadcast-box {
                    width: 100%;
                    height: auto;
                    color: #868d9a;
                    padding: 30px 0;
                    border-bottom: 1px dashed #d3d5db;
                }

                .broadcast-box {
                    max-width: 100%;
                    height: auto;
                    color: #868d9a;
                    padding: 30px 0;
                    border-bottom: 1px dashed #d3d5db;
                }

                .broadcast-box:hover {
                    -webkit-transition-property: -webkit-padding-left;
                    transition-property: padding-left;
                    -webkit-transition-duration: 0.5s;
                    transition-duration: 0.5s;
                    -webkit-transition-timing-function: ease;
                    transition-timing-function: ease;
                    max-width: 100%;
                    padding-left: 20px;
                    background: #fff;
                }

                .broadcast-img {
                    max-width: 210px;
                    margin-right: 20px;
                    max-height: 118px;
                    float: left;
                }

                .broadcast-img img {
                    width: 100%;
                    height: 100%;
                }

                .broadcast-info {
                    max-width: 930px;
                    height: 55px;
                    float: left;
                }

                .broadcast-info h1 {
                    color: #273142;
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 10px;
                    padding-top: 10px;
                    cursor: pointer;
                }

                .broadcast-info p {
                    color: #868d9a;
                    font-size: 14px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                }

                .broadcast-info-line {
                    width: 100%;
                    height: 26px;
                }

                .broadcast-info-line span {
                    display: block;
                    width: 65px;
                    height: 26px;
                    line-height: 26px;
                    float: left;
                }

                .broadcast-info-line i {
                    width: 1px;
                    height: 10px;
                    float: left;
                    margin: 8px 20px 0 0;
                    background: #979eaa;
                }

                .broadcast-info-line .time {
                    color: #868d9a;
                    width: 200px;
                    height: 26px;
                    line-height: 26px;
                    float: left;
                }

                .meeting_name{
                    width: 100%;
                    height: 40px;
                    font-size: 20px;
                    // line-height: 40px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
</style>
